import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerViewMode, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { Subscription, delay, fromEvent, map } from 'rxjs';
import { TranslateService } from 'src/app/core/translate';
import { StartEnd } from '../../../core/models/start-end.mode';
import { DateHandlingService } from '../../../core/services/date-handling.service';
import { DateFormatPipe } from '../../pipes/date-format.pipe';

@Component({
    selector: 'app-month-date-picker',
    templateUrl: './month-date-picker.component.html',
    styleUrls: ['./month-date-picker.component.css']
})
export class MonthDatePickerComponent implements OnInit, OnDestroy {
    bsConfigOb;
    colorTheme = '';
    todayPosition = 'left';
    months = [
        'months.january',
        'months.february',
        'months.march',
        'months.april',
        'months.may',
        'months.june',
        'months.july',
        'months.august',
        'months.september',
        'months.october',
        'months.november',
        'months.december'
    ];
    datePickerValue: Date | null = null;
    minMode: BsDatepickerViewMode = 'month';
    noDateSelected = true;
    selectedDate;
    dpCustomButtons: string = `<div class="custom-datepicker-buttons d-flex">
    <button id="dpAllDaysButton"  class="dpCustomButton mat-raised-button white-text bg-purple medium"> ${this.translateService.instant(
        'allMonths'
    )} </button></div>`;
    customButtonsSubscription: Subscription;
    customButtons$;

    @Output() dateChange = new EventEmitter<any>();

    @Input() maxDate: Date = new Date();

    constructor(
        private bsLocaleService: BsLocaleService,
        private dateHandlingService: DateHandlingService,
        private readonly translateService: TranslateService,
        private readonly cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.setDatePickerLang();
        this.configDatePicker();
        this.translateService.currentLang$
            .pipe(
                delay(1000),
                map(lang => {
                    this.setDatePickerLang(lang);
                    this.configDatePicker();
                })
            )
            .subscribe();
    }

    setDatePickerLang(lang: string = 'ar') {
        const months = Object.values(this.translateService.instant(this.months)) as string[];
        const localeConfig = { ...enGbLocale, months };
        defineLocale(lang, localeConfig);
        this.bsLocaleService.use(lang);
    }

    configDatePicker() {
        this.bsConfigOb = {
            minMode: this.minMode,
            adaptivePosition: true,
            dateInputFormat: 'MMMM YYYY',
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            todayPosition: this.todayPosition
        };
    }

    bsDatePickerMonthValueChange(chosenDate: Date, dp) {
        this.selectedDate = new DateFormatPipe(this.translateService).transform(chosenDate, 'MMMM YYYY');
        if (this.datePickerValue) {
            this.noDateSelected = false;
            const monthStartAndEndDates: StartEnd = this.dateHandlingService.getMonthStartAndEndDates(chosenDate);
            this.passToParent(monthStartAndEndDates);
        }
    }

    handler(dp): void {
        const d1 = document.querySelector('.bs-datepicker-container');
        d1.insertAdjacentHTML('beforeend', this.dpCustomButtons);

        const dpTodayButton = document.getElementsByClassName('dpCustomButton');
        this.customButtons$ = fromEvent(dpTodayButton, 'click');

        this.customButtonsSubscription = this.customButtons$.subscribe((event: any) => {
            this.onAllDaysBtnClick(event, dp);
        });
    }

    onAllDaysBtnClick(event, dp) {
        if (event.target.id === 'dpAllDaysButton') {
            this.datePickerValue = null;
            this.noDateSelected = true;
            this.passToParent(null);
            dp.hide();
        }
    }

    passToParent(selectedDate: any | null) {
        this.dateChange.emit(selectedDate);
    }

    ngOnDestroy(): void {
        if (this.customButtonsSubscription) {
            this.customButtonsSubscription.unsubscribe();
        }
    }
}
